import { useEffect, useState } from 'react';
import { ContentView } from '../../../common/global-types/AdvisoryContent';

const useViewPairing = (viewId: number | undefined, contentViews: ContentView[], initialViewId: number) => {
  const [primaryViewId, setPrimaryViewId] = useState<number | undefined>(
    contentViews.find((cv) => cv.contentViewId === initialViewId)?.isModal ? 1 : initialViewId
  );
  const [modalViewId, setModalViewId] = useState<number | undefined>(undefined);

  useEffect(() => {
    if (contentViews.find((cv) => cv.contentViewId === viewId)?.isModal) {
      setModalViewId(viewId);
    } else {
      setModalViewId(undefined);
      setPrimaryViewId(viewId);
    }
  }, [viewId]);

  return {
    primaryViewId,
    modalViewId
  };
};

export default useViewPairing;
